import React, { useState, useEffect, Fragment } from 'react';
import { Link, TableRow, TableCell, Checkbox, TextField } from '@mui/material';
import { getAllTestFromSet } from 'services';
import { useDispatch, useSelector } from 'react-redux';

let tempData: any = [];
let currentItem: any = [];

const SubRow = (props: any) => {
    const [childData, setChildData] = useState([] as any[]);
    const dispatch = useDispatch();

    let dataList: any = useSelector((state: any) => state.dataList);
    let priceItems: any = useSelector((state: any) => state.priceItems);

    let filteredArr: any = priceItems.filter(function (item, index) {
        if (priceItems.indexOf(item) === index)
            return item;
    });

    useEffect(() => {
        if (props.rowData) {
            setChildData(props.rowData);
        }
    }, [props.rowData])

    useEffect(() => {
        if (props.isUpdate === 1) {
            setChildData(props.rowData);
            tempData = [];
            currentItem = [];
            props.parentLoop(props.rowData);
        }
    }, [props.isUpdate])

    const handleNumberOfSample = (event: any, index: any, user: any, type: any) => {
        let newArray = [...childData];
        if (type === 'noOfSamples') {
            newArray[index] = {
                ...newArray[index],
                noOfSamples: parseInt(event.target.value)
            }
            user.noOfSamples = parseInt(event.target.value);
        } else {
            newArray[index] = {
                ...newArray[index],
                testPrice: parseInt(event.target.value)
            }
            user.testPrice = parseInt(event.target.value);
        }
        setChildData(newArray);
        tempArray(newArray, user);
        updateRedux(newArray);
    }

    const tempArray = (arr: any, user: any) => {
        let obj = {
            'associatedTests': user.associatedTests,
            'data': arr,
            'id': user.id
        }
        tempData.push(obj);
        dispatch({ type: 'PRICE_LIST', payload: tempData });
    }

    const updateState = (id: any, itemAttributes: any) => {
        let index = childData.findIndex((x: any) => x.id === id);
        if (index !== -1) {
            let data1 = [
                ...childData.slice(0, index),
                { ...childData[index], ...itemAttributes },
                ...childData.slice(index + 1)
            ]
            setChildData(data1);
        }
    };

    const updateRedux = (newArray: any) => {
        newArray.map((j: any) => {
            filteredArr.map((i: any) => {
                i.data.map((k: any) => {
                    if (k.id === j.id) {
                        i.data = newArray;
                    }
                })
            })
        })

        dataList.map((obj: any) => {
            newArray.map((z: any) => {
                if (obj.id === z.id) {
                    currentItem.push(z);
                }
            })
        })
        let list = filterArrayElement(currentItem);
        dispatch({ type: 'ADD_DATA', payload: list });
    }

    const filterArrayElement = (val: any) => {
        let newArray: any = [];
        let uniqueObject: any = {};
        let i: any;

        for (i in val) {
            let objId = val[i]['id'];
            uniqueObject[objId] = val[i];
        }

        for (i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }

        return newArray;
    }


    const expandRow = (user: any) => {
        if (filteredArr?.length > 0) {
            nextedLoop(filteredArr, user);
        } else {
            innerChildCall(user);
        }
    };

    const nextedLoop = (item: any, user: any) => {
        let found: boolean = false;
        let selectedItem: any = {};
        for (let i = 0; i < item?.length; i++) {
            if (item[i].id === user?.id) {
                selectedItem = item[i];
                found = true;
                break;
            }
        }

        if (found) {
            user.children = selectedItem.data;
            user.id = selectedItem.id;
            updateState(user.id, { isExpanded: true });
            found = false;
        }
        else {
            innerChildCall(user);
        }
    }

    const innerChildCall = (user: any) => {
        user.children = [];
        getAllTestFromSet(props.selectedMatrixType, props.getPriceListId, props.locationId, user.associatedTests).then((res: any) => {
            if (res.status === 200) {
                let obj = {
                    'associatedTests': user.associatedTests,
                    'data': res.data,
                    'id': user.id
                }

                if (tempData.length > 0) {
                    const index = tempData.findIndex((object: any) => object.id === user.id);
                    if (index === -1) {
                        tempData.push(obj);
                        dispatch({ type: 'PRICE_LIST', payload: tempData });
                    }
                } else {
                    tempData.push(obj);
                    dispatch({ type: 'PRICE_LIST', payload: tempData });
                }

                tempData.map((i: any) => {
                    if (i.id === user.id) {
                        user.children = i.data;
                    }
                })
                updateState(user.id, { isExpanded: true });
            }
        });
    }

    const collapseRow = (user: any) => {
        user.children = undefined;
        updateState(user.id, { isExpanded: false });
    };

    const appData = childData?.map((user: any, index: any) => {
        user.isExpanded = false;
        return (
            <Fragment key={user.id}>
                <TableRow key={user.id} style={{ borderBottom: 'none' }}>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>
                        <Checkbox
                            onChange={(event) => props.handleChange(event, user)}
                            name="rowSelected"
                            checked={user?.isSelected}
                        />
                    </TableCell>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>
                        {user?.associatedTests?.length > 0 ?
                            <Link
                                component="button"
                                variant="body2"
                                onClick={() => {
                                    if (user?.children?.length > 0) {
                                        collapseRow(user);
                                    } else {
                                        expandRow(user);
                                    }
                                }}
                            >
                                {user.code}
                            </Link> : <>{user.code}</>}
                    </TableCell>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>{user.testName}</TableCell>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>{user.matrixType}</TableCell>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>{user.methodReference}</TableCell>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>{user.lor}</TableCell>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>{user.isSubContracted ? `Yes - ${user.subContractorName}` : 'No'}</TableCell>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>{user.nataCertified ? 'Yes' : 'No'}</TableCell>
                    <TableCell style={{ padding: '4px', fontSize: '12px', borderBottom: 'none' }}>
                        <TextField
                            id="outlined-basic"
                            type="number"
                            name="noOfSamples"
                            label=""
                            sx={{
                                '.MuiOutlinedInput-input': {
                                    width: '75px',
                                    padding: '8px 10px',
                                    fontSize: '12px'
                                }
                            }}
                            variant="outlined"
                            size="small"
                            value={user.noOfSamples}
                            onChange={(event: any) => handleNumberOfSample(event, index, user, 'noOfSamples')}
                        />
                    </TableCell>
                    <TableCell style={{ padding: '4px', borderBottom: 'none' }}>
                        <TextField
                            id="outlined-basic"
                            type="number"
                            label=""
                            name="testPrice"
                            variant="outlined"
                            sx={{
                                '.MuiOutlinedInput-input': {
                                    width: '75px',
                                    padding: '8px 10px',
                                    fontSize: '12px'
                                }
                            }}
                            size="small"
                            value={user.testPrice}
                            onChange={(event: any) => handleNumberOfSample(event, index, user, 'testPrice')}
                        />
                    </TableCell>
                    <TableCell style={{ padding: '4px', borderBottom: 'none' }}>{(user.noOfSamples * user.testPrice).toFixed(2)}</TableCell>
                </TableRow>
                {user?.children?.length > 0 &&
                    <SubRow
                        rowData={user.children}
                        handleChange={props.handleChange}
                        expandRow={expandRow}
                    />}
            </Fragment>
        );
    });

    return (
        <Fragment>{appData}</Fragment>
    )
}

export default SubRow;
